import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsuarioEmpresaInserirComponent } from './usuario-empresa-inserir.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: UsuarioEmpresaInserirComponent}
  ])],
  exports: [RouterModule]
})
export class UsuarioEmpresaInserirRoutingModule { }
